jQuery(document).ready(function($) {

 var $window = $(window),
	  body = $('body'),
	  deviceAgent = navigator.userAgent.toLowerCase(),
	  isMobile = deviceAgent.match(/(iphone|ipod|android|iemobile)/),
	  isMobileAlt = deviceAgent.match(/(iphone|ipod|ipad|android|iemobile)/),
	  isAppleDevice = deviceAgent.match(/(iphone|ipod|ipad)/),
	  sIEMobile = deviceAgent.match(/(iemobile)/),
	  isSafari = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1 &&  navigator.userAgent.indexOf('Android') == -1,
      windowW = $window.width(),
	  header = $('.header');

	/* detect touch */
	if("ontouchstart" in window){
		document.documentElement.className = document.documentElement.className + " touch";
	}

    

/****** LOAD ANIMATION *******/

  $('body').addClass('loaded');
	
	

  /***** AOS ******/
	
	AOS.init();
	window.addEventListener('load', AOS.refresh);	
	
	
	
	/**** TABLEAU ****/
	
	$("table").wrap('<div class="table-wrapper"></div>');
	
   /**** Changement du header au scroll ****/
	
	
	if (windowW >= 992 ) { 
	
	var scroll = $window.scrollTop();
			if (scroll >= 70) {
				body.addClass('header-changed');
			} else {
				body.removeClass('header-changed');
			}

		$window.scroll(function() {
		   var scroll = $window.scrollTop();
			if (scroll >= 70) {
				body.addClass('header-changed');
			} else {
				body.removeClass('header-changed');
			}
		});	
		
	} else {
		
		var lastScrollTop = 0;
		var $header       = $( '.menu-mobile' );
		var headerBottom  = $header.position().top + $header.outerHeight( true );

		  $window.scroll( function() {
				  var windowTop  = $window.scrollTop();

				  // Add custom sticky class 
				  if ( windowTop >= headerBottom ) {
					  $header.addClass( 'myprefix-maybe-sticky' );
				  } else {
					  $header.removeClass( 'myprefix-maybe-sticky' );
					  $header.removeClass( 'myprefix-show' );
				  }

				  // Show/hide
				  if ( $header.hasClass( 'myprefix-maybe-sticky' ) ) {
					  if ( windowTop <= headerBottom || windowTop < lastScrollTop ) {
						  $header.addClass( 'myprefix-show' );
					  } else {
						  $header.removeClass( 'myprefix-show' );
						  $('body').removeClass('mobile-menu_open');
					  }
				  }
				  lastScrollTop = windowTop;
		  } );
		
	}
	
	
	
 /****** MENU MOBILE ******/

    
    $(document).on('click', '.menu__btn', function() {
        $('body').toggleClass('mobile-menu_open');
        return false;
    });	
	
	
	
/****** CONTACT ******/
    
     $(document).on('click', '.cta-contact', function() {
         $('body').addClass('contact-open'); 
		 $('body').removeClass('mobile-menu_open');
         return false;
    }); 
    
     $(document).on('click', '.form-contact .nav-close, .form-contact .back', function() {
         $('body').removeClass('contact-open');
         return false;
      });
    

	
	
  /****** SCROLLTO *******/

    $('a[href*="#"]:not([href="#"]):not(.cta-contact)').click(function () {
     
       var headerH = $('header').height();

       if($("body").hasClass("mobile-menu_open")) {
            $('body').removeClass('mobile-menu_open');
       }
       
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
            $('html,body').animate({ scrollTop: target.offset().top - headerH }, 500 );
            return false;
          }
        }
    });

  
  var hashLink = window.location.hash;
   if ($(hashLink).length) { 
        if(windowW >= 962) { 
          var  headerH = 162;
       } else {
          var  headerH = 100;
       }
       window.scroll(0,0);
       setTimeout( function() {
           $('html, body').animate({  scrollTop: $(window.location.hash).offset().top - headerH }, 500);
       });
   }	
	
	
  
	/****** TIMELINE *******/
	
	if ( $(".apropos" ).length ) {
	
		var $slider = $('.timeline-slider');

		  $slider.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: false,
			speed: 400,
			arrows: false,          // on gère les flèches à l’extérieur
			dots: false,
			centerMode: false,
			adaptiveHeight: false,
			// Si tu veux des largeurs différentes par carte, mets variableWidth: true
			responsive: [
			  { breakpoint: 769,  settings: { slidesToShow: 2 } }
			]
		  });

		  $('.tl-prev').on('click', function(){ $slider.slick('slickPrev'); }); 
		  $('.tl-next').on('click', function(){ $slider.slick('slickNext'); });
	
	}
	
	
/****** GALERIE PRODUITS *******/	
 	

	function initGallery(gallery) {
	  if (!gallery || gallery.dataset.acfgalInit === "1") return;

	  const main    = gallery.querySelector('.js-acfgal-main');
	  const mainImg = gallery.querySelector('.js-acfgal-main-img');
	  const caption = gallery.querySelector('.js-acfgal-caption');

	  if (!main || !mainImg) return;

	  gallery.dataset.acfgalInit = "1";

	  // Helpers
	  const getMainUrl = () => (mainImg.currentSrc || mainImg.src || "");

	  const updateCaption = (text) => {
		if (!caption) return;
		const title = (text || '').trim();

		if (title) {
		  caption.textContent = title;
		  caption.style.display = '';
		  if (getComputedStyle(caption).display === 'none') {
			caption.style.display = 'block';
		  }
		} else {
		  caption.textContent = '';
		  caption.style.display = 'none';
		}
	  };

	  const setMain = (url) => {
		if (!url) return;

		mainImg.src = url;
		mainImg.removeAttribute('srcset');
		mainImg.removeAttribute('sizes');

		main.style.backgroundImage = "url('" + url + "')";
	  };

	  // Styles minimum
	  main.style.backgroundRepeat   = 'no-repeat';
	  main.style.backgroundPosition = '50% 50%';
	  main.style.backgroundSize     = '100%';

	  // Init main bg
	  setMain(getMainUrl());

	  // Init caption
	  const activeThumb = gallery.querySelector('.js-acfgal-thumb.is-active');
	  if (activeThumb) {
		updateCaption(activeThumb.getAttribute('data-title'));
	  } else {
		updateCaption(gallery.getAttribute('data-main-title') || '');
	  }

	  // Click miniatures
	  gallery.addEventListener('click', function (e) {
		const thumb = e.target.closest('.js-acfgal-thumb');
		if (!thumb || !gallery.contains(thumb)) return;

		const large = thumb.getAttribute('data-large');
		if (!large) return;

		setMain(large);
		updateCaption(thumb.getAttribute('data-title'));

		gallery.querySelectorAll('.js-acfgal-thumb.is-active')
		  .forEach(el => el.classList.remove('is-active'));
		thumb.classList.add('is-active');
	  });

	  // Zoom logic
	  function setZoom(on) {
		if (on) {
		  main.classList.add('is-zooming');
		  main.style.backgroundSize = '200%';
		  mainImg.style.opacity = '0';
		} else {
		  main.classList.remove('is-zooming');
		  main.style.backgroundSize = '100%';
		  main.style.backgroundPosition = '50% 50%';
		  mainImg.style.opacity = '';
		}
	  }

	  const canHover = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

	  // =========================
	  // DESKTOP
	  // =========================
	  if (canHover) {

		main.style.cursor = 'zoom-in';

		main.addEventListener('mouseenter', function () {
		  setMain(getMainUrl());
		  setZoom(true);
		});

		main.addEventListener('mouseleave', function () {
		  setZoom(false);
		});

		main.addEventListener('mousemove', function (e) {
		  const r = main.getBoundingClientRect();
		  const x = ((e.clientX - r.left) / r.width) * 100;
		  const y = ((e.clientY - r.top) / r.height) * 100;
		  main.style.backgroundPosition = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
		});

	  } 

	  // =========================
	  // MOBILE (Option B)
	  // =========================
	  else {

		let zoomed = false;

		// ✅ Autorise le scroll vertical par défaut
		main.style.touchAction = 'pan-y';

		main.addEventListener('click', function () {
		  setMain(getMainUrl());
		  zoomed = !zoomed;
		  setZoom(zoomed);

		  // Quand zoom actif → on capture le drag
		  main.style.touchAction = zoomed ? 'none' : 'pan-y';
		});

		main.addEventListener('pointermove', function (e) {
		  if (!zoomed) return;

		  const r = main.getBoundingClientRect();
		  const x = ((e.clientX - r.left) / r.width) * 100;
		  const y = ((e.clientY - r.top) / r.height) * 100;
		  main.style.backgroundPosition = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
		});

	  }
	}

	// Init
	function initAll() {
	  document.querySelectorAll('.acf-product-gallery[data-acf-gallery]').forEach(initGallery);
	}

	if (document.readyState === 'loading') {
	  document.addEventListener('DOMContentLoaded', initAll);
	} else {
	  initAll();
	}

	// Support Elementor / AJAX
	const obs = new MutationObserver(initAll);
	obs.observe(document.documentElement, { childList: true, subtree: true });

	
 /****** AJAX *******/

	
 var loadMoreLabel = null;	
	
  function getSelectedSolutions() {
    var ids = [];
    $('#category-filter input[type="checkbox"]:checked').each(function () {
      ids.push($(this).val());
    });
    return ids;
  }
	
 // Création du bouton dans la même structure que ton HTML
  function createLoadMoreButton(ppp, max) {
    var label = loadMoreLabel || 'Voir plus de projets';

    var html = '' +
      '<div class="row">' +
        '<div class="col-lg-12 text-center">' +
          '<a href="#" id="load-more-posts" class="cta"' +
             ' data-current="1"' +
             ' data-ppp="' + ppp + '"' +
             ' data-max="' + max + '"' +
             ' data-label="' + label.replace(/"/g, '&quot;') + '">' +
            '<span>' + label + '</span>' +
          '</a>' +
        '</div>' +
      '</div>';

    return $(html);
  }	
	

  function updateButtonVisibility(btn, page, max) {
    if (!btn.length) return;

    if (page >= max || max === 0) {
      // supprime toute la row du bouton
      btn.closest('.row').remove();
    } else {
      btn.prop('disabled', false);
      btn.data('current', page);
      btn.data('max', max);
    }
  }

  function fetchCases(page, replace) {
    var $grid = $('.posts-row');
    var $btn  = $('#load-more-posts');
    var ppp   = $btn.length ? parseInt($btn.data('ppp'), 10) : 6;
    var solutions = getSelectedSolutions();

    if (!replace && $btn.length) {
      $btn.prop('disabled', true);
    }

    $.post(EtudesAjax.url, {
      action: 'etudes_cas_filter',
      nonce: EtudesAjax.nonce,
      page: page,
      ppp: ppp,
      solutions: solutions
    }).done(function (resp) {
      if (!resp.success) return;

      if (replace) {
        // on remplace la grille
        $grid.html(resp.data.html);

        // on supprime l’ancien bouton (s’il existe)
        $('#load-more-posts').closest('.row').remove();

        // si plusieurs pages -> on recrée le bouton
        if (resp.data.max > 1) {
          var newBtnRow = createLoadMoreButton(ppp, resp.data.max);
          // on l’ajoute après la grille
          $grid.parent().append(newBtnRow);
        }

      } else {
        // on ajoute les nouveaux posts à la suite
        $grid.append(resp.data.html);
        updateButtonVisibility($btn, resp.data.page, resp.data.max);
      }
    }).fail(function () {
      if (!replace && $btn.length) {
        $btn.prop('disabled', false);
      }
    });
  }

  // Init : récupérer le label initial du bouton
  $(function(){
    var $btn = $('#load-more-posts');
    if ($btn.length) {
      var dataLabel = $btn.data('label');
      if (dataLabel) {
        loadMoreLabel = dataLabel;
      } else {
        loadMoreLabel = $.trim($btn.text());
      }
    }
  });
	
	var filtreOpen = false;
	

	$(document).on('click', '.cta-filtre', function() {
		if ( filtreOpen == false) {
			$('.filtre').slideToggle(200);
			filtreOpen = true;
		} else {
			$('.filtre').slideToggle(200);
			 filtreOpen = false;
		}
		return false;
	});


  // Empêcher le submit classique
  $(document).on('submit', '#category-filter', function (e) {
    e.preventDefault();
    fetchCases(1, true); // page 1, on remplace le contenu
  });

  // Changement de checkbox => filtre AJAX
  $(document).on('change', '#category-filter input[type="checkbox"]', function () {
	$('.filtre').slideToggle(200);
	filtreOpen = false;
    fetchCases(1, true);
  });

  // Bouton "Voir plus de projets"
  $(document).on('click', '#load-more-posts', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var current = parseInt($btn.data('current'), 10) || 1;
    fetchCases(current + 1, false); // on ajoute à la grille
  });
	

});
